import { Component, AfterViewInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { ActivatedRoute } from '@angular/router';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { DataService } from '@services/data.service';
import { TranslateService } from '@services/translate.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'scanner-ticket-component',
  styleUrls: ['../cashout/newCashout/cashout.new.sass'],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './scanner-ticket.component.html',
})
export class ScannerTicketComponent implements AfterViewInit, OnDestroy {
  slipId: number;
  slipDetailList = [];
  couponDetailList: any[];
  isLive = false;
  slipPassword: number;
  cashoutItem: any;
  cashoutApproveSlipId = 0;

  intervalListener: any;
  isInfoOpen = true;
  isJacktimeActive = environment?.isJacktimeActive || false;

  constructor(
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _ApiService: ApiService,
    private route: ActivatedRoute,
    private _DataHelper: DataHelper,
    public _LZ: LocalizationService,
    private _Router: Router,
    public _DataService: DataService,
    private _TranslateService: TranslateService
  ) {
    this.route.params.subscribe(params => {
      const paramsFromRouter = params['slipid'];
      // last 3 chars are password
      this.slipPassword = parseInt(paramsFromRouter.toString().substring(paramsFromRouter.toString().length - 3));

      // except last 3 chars are slip id
      this.slipId = parseInt(paramsFromRouter.toString().substring(0, paramsFromRouter.toString().length - 3));
    });
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('betting_slip_details');
    this.getSlipDetailAndPass();
  }

  getSlipDetail() {
    this._ApiService.getScannerSlipDetail(this.slipId.toString().substring(0)).then(x => {
      this.slipDetailList = x;
      this.isLive = x.filter((i: any) => i.BetTypeId === 1).length > 0;
    });
  }
  getSlipDetailAndPass() {
    this._ApiService.getScannerSlipOneBySlipIdAndPass(this.slipId, this.slipPassword).then(x => {
      if (x === undefined) return;
      if (x === '') return;

      this.couponDetailList = x;
      this.getSlipDetail();
      this.getCashoutItem();
      this.intervalListener = setInterval(() => {
        this.getCashoutItem();
      }, 10 * 1000);
    });
  }

  getCashoutItem() {
    this._DataService.apiCalls.getCashoutValueExternal({ SlipId: this.slipId, CashoutValue: 0 }).then((x: any) => {
      if (x.status === true && x.data.length > 0) {
        this.cashoutItem = x.data[0];
      }
    });
  }
  ngOnDestroy() {
    if (this.intervalListener) {
      clearInterval(this.intervalListener);
    }
  }

  cashoutApprove(id) {
    this.cashoutApproveSlipId = id;
  }

  cashoutModify() {
    this.cashoutApproveSlipId = 0;
  }
  infoCloser() {
    this.isInfoOpen = false;
  }

  cashOut(slipId, cashOutValue) {
    const cv = this.cashoutItem;

    const currentCashoutSlip = this.cashoutItem;
    const isLiveMatch = currentCashoutSlip.isLive;
    cv.cashoutSubmitMessageIsActive = true;

    this._UiHelper.setLoadingDialog(true);
    const element = document.querySelector('#cont_antiforgerytoken input') as HTMLInputElement;
    this._ApiService.setAntiForgeryToken(element.value);
    setTimeout(
      () => {
        this._ApiService
          .cashoOutPayAnonymous(slipId + '' + this.slipPassword, cashOutValue)
          .then(result => {
            cv.cashoutSubmitMessageIsActive = false;
            this._UiHelper.setLoadingDialog(false);

            if (!(result && Array.isArray(result) && result.length > 0)) {
              const t_message = this._TranslateService.instant('NEW_CASHOUT.STATE.notGiving');
              this._UiHelper.errorSnackBar(t_message, '');
              return;
            }

            if (result[0].ResultId == 1) {
              const t_message = this._TranslateService.instant('cashoutsuccess');
              this._UiHelper.successSnackBar(t_message, '');
              // this._router.navigate(['/home']);
            } else {
              const t_message = this._TranslateService.instant(result[0].ResultMessage, null);
              this._UiHelper.errorSnackBar(t_message, '');
            }
          })
          .catch(i => {
            console.error('Cashout not giving: catch');
            const t_message = this._TranslateService.instant('NEW_CASHOUT.STATE.notGiving');
            this._UiHelper.errorSnackBar(t_message, '');
          })
          .finally(() => {
            this.getSlipDetailAndPass();
          });
      },
      isLiveMatch ? 8 * 1000 : 0
    );
  }

  goEventDetail(e) {
    this._Router.navigate(['/eventdetail', e]);
  }

  reverse(e) {
    if (e.indexOf(':') > -1) {
      return e.split(':')[1] + ':' + e.split(':')[0];
    } else return e;
  }

  trackBySlipId(index: number, item: any) {
    return item.BetradarMatchId;
  }
}
